import React from "react";
import { Popover } from "@mui/material";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const PopoverStyled = styled(Popover)(
  ({ position, placement, suppressArrow, width }) => ({
    "& .MuiPaper-root": {
      width,
      overflowX: "unset",
      overflowY: "auto",
      maxHeight: "450px",
      boxShadow: "0px 0px 2px 1.5px rgba(0,0,0,0.1)",
      borderRadius: "2px",
      ...(placement && {
        transform:
          placement === "top"
            ? `translate(calc(50% - clamp(16px,${position}%,calc(100% - 16px))), ${
              suppressArrow ? 0 : "-8px"
            }) !important`
            : placement === "bottom"
              ? `translate(calc(50% - clamp(16px,${position}%,calc(100% - 16px))), ${
                suppressArrow ? 0 : "8px"
              }) !important`
              : placement === "right"
                ? `translate(${
                  suppressArrow ? 0 : "8px"
                },calc(50% - clamp(16px,${position}%,calc(100% - 16px)))) !important`
                : `translate(${
                  suppressArrow ? 0 : "-8px"
                },calc(50% - clamp(16px,${position}%,calc(100% - 16px)))) !important`,
      }),
    },
  })
);

const Arrow = styled("div")(({ position, placement, list }) => ({
  position: "relative",
  display: "block",
  "&:before": {
    backgroundColor: "white",
    content: "\"\"",
    display: "block",
    position: "absolute",
    width: 16,
    height: 16,
    zIndex: 9,
    boxShadow: "-2px -2px 2px -0.5px rgba(0,0,0,0.1)",
    transform:
      placement === "top"
        ? "translateY(50%) rotate(-135deg)"
        : placement === "bottom"
          ? "translateY(-50%) rotate(45deg)"
          : placement === "right"
            ? "translateX(-50%) rotate(-45deg)"
            : "translateX(50%) rotate(135deg)",
    top:
      placement === "left" || placement === "right"
        ? `calc(clamp(16px,${(list.height * position) / 100}px,${
          list.height - 16
        }px) - 8px)`
        : "initial",
    bottom: placement === "top" ? `-${list.height}px` : "initial",
    left:
      placement === "bottom" || placement === "top"
        ? `calc(clamp(16px,${(list.width * position) / 100}px,${
          list.width - 16
        }px) - 8px)`
        : "initial",
    right: placement === "left" ? "0" : "initial",
  },
}));

export const SFDropdownBase = ({
  id,
  open,
  anchorEl,
  trigger,
  onClose,
  disableScrollLock = false,
  position = 50,
  placement,
  suppressArrow = false,
  htmlPlacement,
  children,
  anchorOrigin = null,
  transformOrigin = null,
  list,
  className,
}) => {
  return (
    <>
      {trigger}
      <PopoverStyled
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={
          anchorOrigin ?? {
            vertical:
              placement === "top" || placement === "bottom"
                ? placement
                : "center",
            horizontal:
              placement === "left" || placement === "right"
                ? placement
                : "center",
          }
        }
        transformOrigin={
          transformOrigin ?? {
            vertical:
              placement === "top"
                ? "bottom"
                : placement === "bottom"
                  ? "top"
                  : "center",
            horizontal:
              placement === "left"
                ? "right"
                : placement === "right"
                  ? "left"
                  : "center",
          }
        }
        disableScrollLock={disableScrollLock}
        disableEnforceFocus={true}
        position={position}
        placement={!anchorOrigin && !transformOrigin && placement}
        suppressArrow={suppressArrow}
        {...(htmlPlacement && { container: htmlPlacement })}
        className={className}
      >
        {!suppressArrow && placement && (
          <Arrow position={position} placement={placement} list={list} />
        )}
        {children}
      </PopoverStyled>
    </>
  );
};

export default SFDropdownBase;
